/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Pro_PriceInputs */

const en_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34.99`)
};

const de_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34,99`)
};

const fr_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34,99`)
};

const es_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34,99`)
};

const it_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34,99`)
};

const nl_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34,99`)
};

const pl_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`34,99 EUR`)
};

const fi_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`34,99 EUR`)
};

const da_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34,99`)
};

const sv_settings_pro_price = /** @type {(inputs: Settings_Pro_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR 34,99`)
};

/**
* | output |
* | --- |
* | "EUR 34.99" |
*
* @param {Settings_Pro_PriceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_pro_price = /** @type {((inputs?: Settings_Pro_PriceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Pro_PriceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_pro_price(inputs)
	if (locale === "fr") return fr_settings_pro_price(inputs)
	if (locale === "es") return es_settings_pro_price(inputs)
	if (locale === "it") return it_settings_pro_price(inputs)
	if (locale === "nl") return nl_settings_pro_price(inputs)
	if (locale === "pl") return pl_settings_pro_price(inputs)
	if (locale === "fi") return fi_settings_pro_price(inputs)
	if (locale === "da") return da_settings_pro_price(inputs)
	if (locale === "sv") return sv_settings_pro_price(inputs)
	return en_settings_pro_price(inputs)
});